module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "choice-character__slide"
  }, [_c('div', {
    staticClass: "slide-parent"
  }, [_c('div', {
    staticClass: "slide-translate",
    style: ({
      transform: _vm.translate,
      width: _vm.width
    })
  }, _vm._l((_vm.dataPlayer), function(player, i) {
    return _c('div', {
      staticClass: "slide-item",
      class: [i === 0 ? 'active' : '', i === 1 ? 'next-active' : '']
    }, [(!_vm.getMobile) ? [_c('h2', {
      staticClass: "title"
    }, [_vm._v(_vm._s(player.name))]), _vm._v(" "), _c('div', {
      staticClass: "slide-player__box"
    }, [_c('div', [_c('div', {
      staticClass: "slide-player__img"
    }, [_c('img', {
      attrs: {
        "src": player.img,
        "alt": "player.name"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "slide-player__infos"
    }, [_c('div', [_c('p', [_c('span', [_vm._v("Age :")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(player.age))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("Taille :")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(player.size))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("Nationalité :")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(player.country))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("Poste :")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(player.role))])])]), _vm._v(" "), _c('div', {
      staticClass: "slide-player__descr"
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(player.descr)
      }
    })])])])]), _vm._v(" "), _c('div', {
      staticClass: "slide-player__go-container"
    }, [_c('router-link', {
      staticClass: "slide-player__go btn",
      attrs: {
        "to": "/valider-son-personnage"
      },
      nativeOn: {
        "click": function($event) {
          _vm.setPlayer($event)
        }
      }
    }, [_vm._v("\n              Jouer avec " + _vm._s(player.name) + "\n            ")])], 1)] : [_c('h2', {
      staticClass: "title"
    }, [_vm._v(_vm._s(player.name))]), _vm._v(" "), _c('div', {
      staticClass: "slide-player__box"
    }, [_c('div', [_c('div', {
      staticClass: "slide-player__infos"
    }, [_c('div', [_c('p', [_c('span', [_vm._v("Age :")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(player.age))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("Taille :")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(player.size))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("Nationalité :")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(player.country))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("Poste :")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(player.role))])])]), _vm._v(" "), _c('div', {
      staticClass: "slide-player__img"
    }, [_c('img', {
      attrs: {
        "src": player.img,
        "alt": "player.name"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "slide-player__go-container"
    }, [_c('router-link', {
      staticClass: "slide-player__go btn",
      attrs: {
        "to": "/valider-son-personnage"
      },
      nativeOn: {
        "click": function($event) {
          _vm.setPlayer($event)
        }
      }
    }, [_vm._v("\n                    Jouer avec " + _vm._s(player.name) + "\n                  ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "slide-player__descr"
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(player.descr)
      }
    })])])])])]], 2)
  })), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeIn"
    }
  }, [(_vm.actual !== 0) ? _c('button', {
    staticClass: "slide-btn slide-btn--prev",
    on: {
      "click": _vm.prevSlide
    }
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeIn"
    }
  }, [(_vm.actual !== _vm.dataPlayer.length - 1) ? _c('button', {
    staticClass: "slide-btn slide-btn--next",
    on: {
      "click": _vm.nextSlide
    }
  }) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-113dfa13"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/choice-character/ChoiceCharacterSlide.vue
// module id = 82
// module chunks = 0